/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import React, { useState, useEffect } from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";
import apiClient from "../../../../apiClient";
import { Password } from "@mui/icons-material";
import { FilledInput, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function AddLandlord({ onClose, onSuccess, editFormData }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [state, setState] = useState([]);
  const [district, setDistrict] = useState([]);
  const [city, setCity] = useState([]);
  const [location, setLocation] = useState([]);
  const [editData, setEditData] = useState(editFormData);
  console.log("Edit Data in AddLandlord:", editData);

  const [formData, setFormData] = useState({
    name: editData ? editData.name : "",
    email: editData ? editData.email : "",
    password: editData ? editData.password : "",
    phone: editData ? editData.phone : "",
    state: editData ? editData.state : "",
    city: editData ? editData.city : "",
    district: editData ? editData.district : "",
    location: editData ? editData.location : "",
    address: editData ? editData.address : "",
    images: editData ? editData.images : "",
  });

  useEffect(() => {
    getState();
  }, []);

  const getState = async () => {
    const response = await apiClient.get("/admin/state");
    if (response.status === 200) {
      const sortedStates = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setState(sortedStates);
    }
  };

  const getDistrict = async (value) => {
    const response = state && (await apiClient.get(`/admin/district/state/${value}`));
    if (response.status === 200) {
      const sortedDistrict = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setDistrict(sortedDistrict);
    }
  };

  const getCity = async (value) => {
    const response = await apiClient.get(`/admin/cites/district/${value}`);
    if (response.status === 200) {
      const sortedCity = response.data.sort((a, b) => a.name.localeCompare(b.name));
      setCity(sortedCity);
    }
  };

  const getLocation = async (city) => {
    const response = await apiClient.get(`/admin/location/cites/${city}`);
    if (response.status === 200) {
      setLocation(response.data);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "state") {
      console.log("State:", value);
      let stateID = value && state.find((item) => item.name === value)._id;
      value && getDistrict(stateID);
    }
    if (name === "district") {
      let districtID = value && district.find((item) => item.name === value)._id;
      value && getCity(districtID);
    }
    if (name === "city") {
      let cityID = value && city.find((item) => item.name === value)._id;
      value && getLocation(value);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle form submission logic here
    const isEdit = editData && Object.keys(editData).length > 0; // Check if editData exists
    try {
      console.log("Form data submitted:", formData);
      const endpoint = isEdit ? `/admin/landlord/update/${editData._id}` : "/admin/landlord"; // Use ID for PUT
      const method = isEdit ? apiClient.put : apiClient.post; // PUT for edit, POST for create
      const response = await method(endpoint, formData);
      if (response.status === 200) {
        if (response.data.status === "success") {
          onSuccess();
          onClose();
        } else if (response.data.status === "false") {
          console.error("Error creating Landlord:", response.data.message);
          // showing failed message in snackbar
          onSuccess(response.data.message);
          onClose();
        }
      }
    } catch (error) {
      console.error(isEdit ? "Error updating Landlord:" : "Error creating Landlord:", error);
    }
  };

  return (
    <Card id="add-coupons">
      <MDBox p={4}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} lg={12}>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Email ID"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.Password}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Mobile"
                name="phone"
                type="number"
                max={10}
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">State</InputLabel>
                <Select
                  label="state"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select State</em>
                  </MenuItem>
                  {state &&
                    state.length > 0 &&
                    state.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">District</InputLabel>
                <Select
                  label="District"
                  name="district"
                  value={formData.district}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select District</em>
                  </MenuItem>
                  {district &&
                    district.length > 0 &&
                    district.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">City</InputLabel>
                <Select
                  label="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  required
                  sx={{
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select City</em>
                  </MenuItem>
                  {city &&
                    city.length > 0 &&
                    city.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <FormControl fullWidth size="medium" sx={{ mt: 0 }}>
                <InputLabel id="state-label">Location</InputLabel>
                <Select
                  label="Location"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  IconComponent={ArrowDropDownIcon}
                  required
                  sx={{
                    "& .MuiSelect-icon": {
                      color: "blue",
                      fontSize: "2rem",
                    },
                    height: "46px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MenuItem value="">
                    <em>Select Location</em>
                  </MenuItem>
                  {location &&
                    location.length > 0 &&
                    location.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        {item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                multiline
                rows={4}
              />
            </Grid>
            <Grid item xs={8}>
              <FilledInput
                type="file"
                name="images"
                value={formData.images}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={8}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ color: "#fff" }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </MDBox>
    </Card>
  );
}

export default AddLandlord;
